module.exports = __webpack_public_path__ + "img/logo2.629cd924.png";